export const layout = [
  {
    name: 'RegularBgrEntity',
    objects: [
      {
        name: 'b',
        type: 'Graphics',
        width: 1920,
        height: 1080,
        color: '0x101130',
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: 0,
          },
        },
      },
      {
        name: 'bp',
        type: 'Graphics',
        width: 1080,
        height: 1920,
        color: '0x101130',
        resize: true,
        orientation: {
          port: {
            x: 0,
            y: 0,
          },
        },
      },
      {
        name: 'back',
        type: 'Image',
        width: 3200,
        height: 1480,
        scale: 2.7,
        images: ['images/init/background_l.jpeg'],
        orientation: {
          land: {
            x: -800,
            y: -200,
          },
        },
      },
      {
        name: 'back-p',
        type: 'Image',
        width: 1480,
        height: 2320,
        scale: 1.93,
        images: ['images/init/background_P.jpeg'],
        orientation: {
          port: {
            x: -200,
            y: -250,
          },
        },
      },
      {
        name: 'zombies-anim-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'zombies-anim-land',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          land: {
            x: -100,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'lights-anim-port',
        type: 'AnimationSpine',
        width: 1080,
        height: 1920,
        animation: 'lights-anim-port',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          port: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'reels-anim-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'reels-anim-land',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'reels-anim-port',
        type: 'AnimationSpine',
        width: 1080,
        height: 1920,
        animation: 'reels-anim-port',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          port: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'ribbons-anim-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'ribbons-anim-land',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          land: {
            x: -300,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'hands-on-reels-anim-port',
        type: 'AnimationSpine',
        width: 1080,
        height: 1920,
        animation: 'hands-on-reels-anim-port',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          port: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'hand-05-anim-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'hand-05-anim-land',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'hands-stones-ribbons-anim-port',
        type: 'AnimationSpine',
        width: 1080,
        height: 1920,
        animation: 'hands-stones-ribbons-anim-port',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          port: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'hand-04-anim-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'hand-04-anim-land',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'logo-p',
        type: 'Image',
        width: 267,
        height: 196,
        scale: 0.25,
        images: ['images/main/logo/logo.png'],
        orientation: {
          port: {
            x: 417.88,
            y: 229.79,
          },
        },
      },
      {
        name: 'hand-03-anim-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'hand-03-anim-land',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'hand-02-anim-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'hand-02-anim-land',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'hand-01-anim-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'hand-01-anim-land',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'logo',
        type: 'Image',
        width: 267.24,
        height: 196.8,
        direction: true,
        scale: 0.25,
        images: ['images/main/logo/logo.png'],
        orientation: {
          land: {
            x: 40.99,
            y: 77.63,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreespinsBgrEntity',
    objects: [
      {
        name: 'fs-back',
        type: 'Image',
        width: 3200,
        height: 1596.77,
        scale: 2.81,
        images: ['images/init/fs-back-land.jpeg'],
        orientation: {
          land: {
            x: -800,
            y: -253.85,
          },
        },
      },
      {
        name: 'backp',
        type: 'Image',
        width: 1480,
        height: 2320,
        scale: 1.93,
        images: ['images/init/fs-back-port.jpeg'],
        orientation: {
          port: {
            x: -200,
            y: -200,
          },
        },
      },
      {
        name: 'heads-fs-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'heads-fs-land',
        oriented: false,
        spine: 'animations/spine/fsBackground/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'heads-fs-port',
        type: 'AnimationSpine',
        width: 1080,
        height: 1920,
        animation: 'heads-fs-port',
        oriented: false,
        spine: 'animations/spine/fsBackground/skeleton.json',
        orientation: {
          port: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'reel-bg',
        type: 'Image',
        width: 1401,
        height: 974,
        scale: 1,
        images: ['images/main/background/reels_fs.png'],
        orientation: {
          land: {
            x: 286.7,
            y: 5.74,
          },
        },
      },
      {
        name: 'fs-bg-p',
        type: 'Image',
        width: 1112.76,
        height: 691.65,
        scale: 0.75,
        images: ['images/main/background/reels_fs.png'],
        orientation: {
          port: {
            x: 0,
            y: 465.94,
          },
        },
      },
      {
        name: 'effects-fs-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'effects-fs-land',
        oriented: false,
        spine: 'animations/spine/fsBackground/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'logo-fs-port',
        type: 'AnimationSpine',
        width: 1080,
        height: 1920,
        animation: 'logo-fs-port',
        oriented: false,
        spine: 'animations/spine/fsBackground/skeleton.json',
        orientation: {
          port: {
            x: 0,
            y: -125,
            scale: 1,
          },
        },
      },
      {
        name: 'effects-fs-port',
        type: 'AnimationSpine',
        width: 1080,
        height: 1920,
        animation: 'effects-fs-port',
        oriented: false,
        spine: 'animations/spine/fsBackground/skeleton.json',
        orientation: {
          port: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'LinesEntity',
    objects: [
      {
        name: 'container',
        type: 'LinesContainer',
        x: 3.03,
        y: 3.03,
        width: 1296.97,
        height: 830.43,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 336.76,
        y: 79.85,
        scale: 1,
      },
      port: {
        x: 20.69,
        y: 537,
        scale: 0.76,
      },
    },
  },
  {
    name: 'ReelsEntity',
    objects: [
      {
        name: 'reel-0',
        type: 'Reel',
        x: 0.76,
        y: 0,
        width: 258,
        height: 834,
      },
      {
        name: 'reel-1',
        type: 'Reel',
        x: 258.76,
        y: 0,
        width: 258,
        height: 834,
      },
      {
        name: 'reel-2',
        type: 'Reel',
        x: 516.76,
        y: 0,
        width: 258,
        height: 834,
      },
      {
        name: 'reel-3',
        type: 'Reel',
        x: 774.76,
        y: 0,
        width: 258,
        height: 834,
      },
      {
        name: 'reel-4',
        type: 'Reel',
        x: 1032.76,
        y: 0,
        width: 258,
        height: 834,
      },
      {
        name: 'mask',
        type: 'Mask',
        x: 0,
        y: 0,
        width: 1300,
        height: 834,
      },
      {
        name: 'swipe',
        type: 'SpinSwipeButton',
        x: 0,
        y: 0,
        width: 1300,
        height: 834,
        alpha: '0',
        runtime: { platform: 'mobile,tablet' },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 334.24,
        y: 74.94,
        scale: 1,
      },
      port: {
        x: 45,
        y: 515,
        scale: 0.76,
      },
    },
  },
  {
    name: 'FreespinsLogoEntity',
    objects: [
      {
        name: 'logo-fs-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'logo-fs-land',
        oriented: false,
        spine: 'animations/spine/fsBackground/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 10,
            scale: 1,
          },
        },
      },
      {
        name: 'endFreespinText-p',
        type: 'Text',
        width: 221.63,
        height: 96.81,
        hide: true,
        text: 'endFreeSpinButton',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 45,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 221.63,
        },
        orientation: {
          port: {
            x: 421.41,
            y: 1453.47,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'HandsEntity',
    objects: [
      {
        name: 'hand-10-anim-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'hand-10-anim-land',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'endFreespinText-p',
        type: 'Text',
        width: 221.63,
        height: 96.81,
        hide: true,
        text: 'endFreeSpinButton',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 45,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 221.63,
        },
        orientation: {
          port: {
            x: 421.41,
            y: 1453.47,
          },
        },
      },
      {
        name: 'hand-09-anim-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'hand-09-anim-land',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'hand-08-anim-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'hand-08-anim-land',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'hand-07-anim-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'hand-07-anim-land',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'hand-06-anim-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'hand-06-anim-land',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
      {
        name: 'stones-anim-land',
        type: 'AnimationSpine',
        width: 1920,
        height: 1080,
        animation: 'stones-anim-land',
        oriented: false,
        spine: 'animations/spine/back/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'SymbolValueEntity',
    objects: [
      {
        name: 'symbol-value',
        type: 'SymbolValuePopup',
        x: 0,
        y: 0,
        width: '258',
        height: '278',
        color: '#cdcdbd',
        texture: 'SymbolValueBack',
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 334.24,
        y: 74.94,
        scale: 1,
      },
      port: {
        x: 45,
        y: 515,
        scale: 0.76,
      },
    },
  },
  {
    name: 'OverReelEntity',
    objects: [
      {
        name: '0',
        type: 'OverReelAnimation',
        x: 0.76,
        y: 0,
        width: 258,
        height: 834,
      },
      {
        name: '1',
        type: 'OverReelAnimation',
        x: 258.76,
        y: 0,
        width: 258,
        height: 834,
      },
      {
        name: '2',
        type: 'OverReelAnimation',
        x: 516.76,
        y: 0,
        width: 258,
        height: 834,
      },
      {
        name: '3',
        type: 'OverReelAnimation',
        x: 774.76,
        y: 0,
        width: 258,
        height: 834,
      },
      {
        name: '4',
        type: 'OverReelAnimation',
        x: 1032.76,
        y: 0,
        width: 258,
        height: 834,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 334.24,
        y: 74.94,
        scale: 1,
      },
      port: {
        x: 45,
        y: 515,
        scale: 0.76,
      },
    },
  },
  {
    name: 'UIFrameEntity',
    objects: [
      {
        name: 'frame',
        type: 'NineSlicePlane',
        width: 10,
        height: 100,
        from: 'atlases/footer.png',
        orientation: {
          land: {
            x: -1500,
            y: 914,
            v: 1,
          },
        },
      },
      {
        name: 'frameP',
        type: 'NineSlicePlane',
        width: 10,
        height: 400,
        from: 'atlases/footer.png',
        orientation: {
          port: {
            x: -1000,
            y: 1700,
            v: 1,
          },
        },
      },
      {
        name: 'net',
        type: 'NineSlicePlane',
        width: 10,
        height: 100,
        from: 'atlases/net-land.png',
        orientation: {
          land: {
            x: -1500,
            y: 1000,
            v: 1,
          },
        },
      },
      {
        name: 'netFrameP',
        type: 'NineSlicePlane',
        width: 10,
        height: 193.94,
        from: 'atlases/net-port.png',
        orientation: {
          port: {
            x: -998.94,
            y: 1875,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'WinAnimationEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 1920,
        height: 1920,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -420,
          },
          port: {
            x: -420,
            y: 0,
          },
        },
      },
      {
        name: 'bigwins',
        type: 'BigWinTitle',
        width: 0,
        height: 0,
        scale: 0.4,
        orientation: {
          land: {
            x: 960,
            y: 511,
          },
          port: {
            x: 540,
            y: 820,
          },
        },
      },
      {
        name: 'you-win-big',
        type: 'BigWinCounter',
        width: 1489.92,
        height: 127,
        fontBitmap: 'bitmap',
        letterSpacing: 10,
        text: '$10.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 150,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1489.92,
        },
        orientation: {
          land: {
            x: 195.22,
            y: 760.73,
          },
          port: {
            x: -218.78,
            y: 1260.73,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'TextLineEntity',
    objects: [
      {
        name: 'line-win-text',
        type: 'LineWinText',
        width: 1399.83,
        height: 203.24,
        fontBitmap: 'bitmap',
        letterSpacing: 10,
        text: '$10.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 175,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1399.83,
        },
        orientation: {
          land: {
            x: 261.66,
            y: 386.51,
          },
          port: {
            x: -148.4,
            y: 765.05,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'MenuBackEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 1920,
        height: 1920,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -420,
          },
          port: {
            x: -420,
            y: 0,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'AutoMenuEntity',
    objects: [
      {
        name: 'loss-0',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 460,
            y: 590,
          },
          port: {
            x: 286.33,
            y: 778,
          },
        },
      },
      {
        name: 'autoselected',
        type: 'Image',
        width: 226,
        height: 103,
        scale: 1.03,
        images: ['images/icons/button-0.png'],
        orientation: {
          port: {
            x: 426.5,
            y: 403.33,
          },
          land: {
            x: 848.57,
            y: 237.66,
          },
        },
      },
      {
        name: 'loss-1',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 719,
            y: 590,
          },
          port: {
            x: 550.33,
            y: 777,
          },
        },
      },
      {
        name: 'prevauto',
        type: 'DecreaseAutoButton',
        width: 42,
        height: 60,
        hitzone: 4,
        scale: 1.76,
        images: [
          'images/icons/bet-left-0.png',
          'images/icons/bet-left-1.png',
        ],
        orientation: {
          port: {
            x: 113.5,
            y: 430,
          },
          land: {
            x: 533.91,
            y: 257,
          },
        },
      },
      {
        name: 'loss-2',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 975,
            y: 590,
          },
          port: {
            x: 289.67,
            y: 913,
          },
        },
      },
      {
        name: 'nextauto',
        type: 'IncreaseAutoButton',
        width: 40,
        height: 60,
        hitzone: 4,
        scale: 1.72,
        images: [
          'images/icons/bet-right-0.png',
          'images/icons/bet-right-1.png',
        ],
        orientation: {
          port: {
            x: 936.5,
            y: 432.5,
          },
          land: {
            x: 1346.75,
            y: 257,
          },
        },
      },
      {
        name: 'loss-3',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 1234,
            y: 590,
          },
          port: {
            x: 552.33,
            y: 909,
          },
        },
      },
      {
        name: 'win-0',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 460,
            y: 820,
          },
          port: {
            x: 302.67,
            y: 1165,
          },
        },
      },
      {
        name: 'win-1',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 718,
            y: 820,
          },
          port: {
            x: 561,
            y: 1163,
          },
        },
      },
      {
        name: 'win-2',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 976,
            y: 820,
          },
          port: {
            x: 297.67,
            y: 1299.33,
          },
        },
      },
      {
        name: 'win-3',
        type: 'AutoButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 1234,
            y: 820,
          },
          port: {
            x: 557,
            y: 1299.33,
          },
        },
      },
      {
        name: 'win',
        type: 'AutoLimitSelectedText',
        width: 991.41,
        height: 70,
        text: 'winlimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 991.41,
        },
        orientation: {
          land: {
            x: 466.25,
            y: 724.33,
          },
          port: {
            x: 40.14,
            y: 1065.67,
          },
        },
      },
      {
        name: 'loss',
        type: 'AutoLimitSelectedText',
        width: 960.94,
        height: 70,
        text: 'losslimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960.94,
        },
        orientation: {
          port: {
            x: 63.73,
            y: 683,
          },
          land: {
            x: 470.16,
            y: 479.33,
          },
        },
      },
      {
        name: 'loss-0',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 460,
            y: 590,
          },
          port: {
            x: 285.33,
            y: 779.67,
          },
        },
      },
      {
        name: 'loss-1',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 719,
            y: 590,
          },
          port: {
            x: 552.67,
            y: 780.33,
          },
        },
      },
      {
        name: 'loss-2',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 975,
            y: 590,
          },
          port: {
            x: 288.67,
            y: 914.33,
          },
        },
      },
      {
        name: 'loss-3',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'noLimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 1234,
            y: 590,
          },
          port: {
            x: 553.33,
            y: 911,
          },
        },
      },
      {
        name: 'win-0',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 460,
            y: 820,
          },
          port: {
            x: 298,
            y: 1166,
          },
        },
      },
      {
        name: 'win-1',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 718,
            y: 820,
          },
          port: {
            x: 556,
            y: 1166,
          },
        },
      },
      {
        name: 'win-2',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 976,
            y: 820,
          },
          port: {
            x: 298,
            y: 1300,
          },
        },
      },
      {
        name: 'win-3',
        type: 'AutoLimitOptionText',
        width: 226,
        height: 99,
        text: 'noLimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 1235,
            y: 820,
          },
          port: {
            x: 556.67,
            y: 1301.33,
          },
        },
      },
      {
        name: 'autoplay',
        type: 'Text',
        width: 852,
        height: 56,
        text: 'autoHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 52,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 852,
        },
        orientation: {
          land: {
            x: 526,
            y: 58,
          },
          port: {
            x: 112,
            y: 186,
          },
        },
      },
      {
        name: 'number',
        type: 'Text',
        width: 866,
        height: 70,
        text: 'numberSpins',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 52,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 866,
        },
        orientation: {
          land: {
            x: 526,
            y: 138,
          },
          port: {
            x: 112,
            y: 308,
          },
        },
      },
      {
        name: 'settings',
        type: 'Text',
        width: 858,
        height: 69,
        text: 'extendedSettings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 52,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 858,
        },
        orientation: {
          land: {
            x: 534,
            y: 383,
          },
          port: {
            x: 112,
            y: 560,
          },
        },
      },
      {
        name: 'auto-carousel',
        type: 'AutoCarousel',
        width: 226,
        height: 95,
        text: '2',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 226,
        },
        orientation: {
          land: {
            x: 848.57,
            y: 237.67,
          },
          port: {
            x: 427.5,
            y: 409,
          },
        },
      },
      {
        name: 'ui-automenu',
        type: 'RadioButton',
        width: 110,
        height: 110,
        deselect: true,
        direction: true,
        scale: 1,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 1316,
            y: 68,
          },
          port: {
            x: 903.67,
            y: 197,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'BetEntity',
    objects: [
      {
        name: 'bet',
        type: 'Text',
        width: 942.67,
        height: 71.84,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 53,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 942.67,
        },
        orientation: {
          land: {
            x: 495.33,
            y: 89.51,
          },
          port: {
            x: 80,
            y: 325,
          },
        },
      },
      {
        name: 'ui-bet',
        type: 'RadioButton',
        width: 110,
        height: 110,
        deselect: true,
        direction: true,
        hitzone: 1,
        scale: 1,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 1317,
            y: 60,
          },
          port: {
            x: 903.18,
            y: 330.18,
          },
        },
      },
      {
        name: 'field',
        type: 'BetField',
        width: 948.53,
        height: 713.81,
        numberOfButtons: 24,
        textPosX: 110,
        textPosY: 50,
        texture: 'button-0',
        orientation: {
          land: {
            x: 490.41,
            y: 210.68,
          },
          port: {
            x: 76.01,
            y: 493.83,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'PaytableEntity',
    objects: [
      {
        name: 'PaytableEntity-header-text',
        type: 'Text',
        x: 0,
        y: 43,
        width: 1920,
        height: 100,
        text: 'paytableHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 72,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'PaytableEntity-jackpot-describe-text',
        type: 'Text',
        x: 471,
        y: 493.83,
        width: 404,
        height: 100.33,
        context: { jackpot: true },
        text: 'jackpotPayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 404,
        },
      },
      {
        name: 'PaytableEntity-free-spins-describe-text',
        type: 'Text',
        x: 1017,
        y: 495.5,
        width: 468,
        height: 100.33,
        context: { jackpot: true },
        text: 'freespinsPayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 468,
        },
      },
      {
        name: 'PrevAutoPage',
        type: 'DecreasePageButton',
        x: 543,
        y: 930,
        width: 24,
        height: 34,
        hitzone: 2,
        scale: 1,
        images: [
          'images/main/paytable/bet-left-0.png',
          'images/main/paytable/bet-left-1.png',
        ],
      },
      {
        name: 'AutoCaruselPage',
        type: 'PageCarousel',
        x: 870,
        y: 930,
        width: 30,
        height: 30,
        scale: 1,
        images: [
          'images/main/paytable/dot-0.png',
          'images/main/paytable/dot-1.png',
        ],
      },
      {
        name: 'NextAutoPage',
        type: 'IncreasePageButton',
        x: 1360,
        y: 930,
        width: 24,
        height: 34,
        hitzone: 2,
        scale: 1,
        images: [
          'images/main/paytable/bet-right-0.png',
          'images/main/paytable/bet-right-1.png',
        ],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 536,
        y: 132,
        width: 852,
        height: 788,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-hot-header-text',
        type: 'Text',
        x: 0,
        y: 150,
        width: 1920,
        height: 100.33,
        text: 'hotHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'PaytableEntity-stickywild-describe-text',
        type: 'Text',
        x: 482.79,
        y: 761.86,
        width: 958.64,
        height: 100.33,
        text: 'stikyWildDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 958.64,
        },
      },
      {
        name: 'sticky',
        type: 'Image',
        x: 452.62,
        y: 212.02,
        width: 1004.84,
        height: 565.22,
        scale: 0.52,
        images: ['images/main/background/styki-wild_paytable.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 536,
        y: 132,
        width: 852,
        height: 788,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-hot-header-text',
        type: 'Text',
        x: 0,
        y: 150,
        width: 1920,
        height: 100.33,
        text: 'hotHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'PaytableEntity-expwild-describe-text',
        type: 'Text',
        x: 480.76,
        y: 761.86,
        width: 958.64,
        height: 100.33,
        text: 'expandingWildDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 958.64,
        },
      },
      {
        name: 'expending',
        type: 'Image',
        x: 453.92,
        y: 217.14,
        width: 1018.59,
        height: 554.98,
        scale: 0.52,
        images: ['images/main/background/zombie_wild.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 536,
        y: 132,
        width: 852,
        height: 788,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-hot-header-text',
        type: 'Text',
        x: 0,
        y: 150,
        width: 1920,
        height: 100.33,
        text: 'hotHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'PaytableEntity-scatter-describe-text',
        type: 'Text',
        x: 639.27,
        y: 565.8,
        width: 637.6,
        height: 293.52,
        text: 'scatterPayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 637.6,
        },
      },
      {
        name: 'scatter',
        type: 'Image',
        x: 829.76,
        y: 289.6,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/1.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 536,
        y: 132,
        width: 852,
        height: 788,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-wild-describe-text',
        type: 'Text',
        x: 641.38,
        y: 563.97,
        width: 636.66,
        height: 299.62,
        text: 'wildPayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 636.66,
        },
      },
      {
        name: 'wild',
        type: 'Image',
        x: 831.8,
        y: 289.6,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/2.png'],
      },
      {
        name: 'PaytableEntity-hot-header-text',
        type: 'Text',
        x: 0,
        y: 150,
        width: 1920,
        height: 100.33,
        text: 'hotHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 536,
        y: 132,
        width: 852,
        height: 788,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-symbols-header-text',
        type: 'Text',
        x: 0,
        y: 150,
        width: 1920,
        height: 100.33,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 400,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 355,
        width: 56,
        height: 43,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 310,
        width: 56,
        height: 43,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 730.16,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 685.16,
        width: 56,
        height: 43,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 640.16,
        width: 56,
        height: 43,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 730,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 685,
        width: 56,
        height: 43,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 640,
        width: 56,
        height: 43,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 400,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 355,
        width: 56,
        height: 43,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 310,
        width: 56,
        height: 43,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '1',
        type: 'Image',
        x: 482.04,
        y: 241.84,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/1.png'],
      },
      {
        name: '2',
        type: 'Image',
        x: 961.42,
        y: 239.22,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/2.png'],
      },
      {
        name: '3',
        type: 'Image',
        x: 482.35,
        y: 588.78,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/3.png'],
      },
      {
        name: 'A',
        type: 'Image',
        x: 962.67,
        y: 594.33,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/A.png'],
      },
      {
        name: '1-3',
        type: 'PayoutText',
        x: 800,
        y: 400,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: '1-4',
        type: 'PayoutText',
        x: 800,
        y: 355,
        width: 160,
        height: 43,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: '1-5',
        type: 'PayoutText',
        x: 800,
        y: 310,
        width: 160,
        height: 43,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: '2-3',
        type: 'PayoutText',
        x: 1280,
        y: 400,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: '2-4',
        type: 'PayoutText',
        x: 1280,
        y: 355,
        width: 160,
        height: 43,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: '2-5',
        type: 'PayoutText',
        x: 1280,
        y: 310,
        width: 160,
        height: 43,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: '3-3',
        type: 'PayoutText',
        x: 800,
        y: 730,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: '3-4',
        type: 'PayoutText',
        x: 800,
        y: 685,
        width: 160,
        height: 43,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: '3-5',
        type: 'PayoutText',
        x: 800,
        y: 640,
        width: 160,
        height: 43,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'A-3',
        type: 'PayoutText',
        x: 1280,
        y: 730.16,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'A-4',
        type: 'PayoutText',
        x: 1280,
        y: 685.16,
        width: 160,
        height: 43,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'A-5',
        type: 'PayoutText',
        x: 1280,
        y: 640.16,
        width: 160,
        height: 43,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 536,
        y: 132,
        width: 852,
        height: 788,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-symbols-header-text',
        type: 'Text',
        x: 0,
        y: 150,
        width: 1920,
        height: 100.33,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 399.37,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 354.37,
        width: 56,
        height: 43,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 309.37,
        width: 56,
        height: 43,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 400,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 355,
        width: 56,
        height: 43,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 310,
        width: 56,
        height: 43,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 740,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 695,
        width: 56,
        height: 43,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 650,
        width: 56,
        height: 43,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 740,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 695,
        width: 56,
        height: 43,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 650,
        width: 56,
        height: 43,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: 'B',
        type: 'Image',
        x: 480.28,
        y: 239.71,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/B.png'],
      },
      {
        name: 'C',
        type: 'Image',
        x: 960.05,
        y: 238.57,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/C.png'],
      },
      {
        name: 'D',
        type: 'Image',
        x: 481.73,
        y: 591.56,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/D.png'],
      },
      {
        name: 'E',
        type: 'Image',
        x: 961.73,
        y: 590.82,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/E.png'],
      },
      {
        name: 'B-3',
        type: 'PayoutText',
        x: 800,
        y: 399.38,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'B-4',
        type: 'PayoutText',
        x: 800,
        y: 354.38,
        width: 160,
        height: 43,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'B-5',
        type: 'PayoutText',
        x: 800,
        y: 309.38,
        width: 160,
        height: 43,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'C-3',
        type: 'PayoutText',
        x: 1280,
        y: 400,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'C-4',
        type: 'PayoutText',
        x: 1280,
        y: 355,
        width: 160,
        height: 43,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'C-5',
        type: 'PayoutText',
        x: 1280,
        y: 310,
        width: 160,
        height: 43,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'D-3',
        type: 'PayoutText',
        x: 800,
        y: 740,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'D-4',
        type: 'PayoutText',
        x: 800,
        y: 695,
        width: 160,
        height: 43,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'D-5',
        type: 'PayoutText',
        x: 800,
        y: 650,
        width: 160,
        height: 43,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'E-3',
        type: 'PayoutText',
        x: 1280,
        y: 740,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'E-4',
        type: 'PayoutText',
        x: 1280,
        y: 695,
        width: 160,
        height: 43,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'E-5',
        type: 'PayoutText',
        x: 1280,
        y: 650,
        width: 160,
        height: 43,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 536,
        y: 132,
        width: 852,
        height: 788,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-symbols-header-text',
        type: 'Text',
        x: 0,
        y: 150,
        width: 1920,
        height: 100.33,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 400,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 355,
        width: 56,
        height: 43,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 310,
        width: 56,
        height: 43,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 400,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 355,
        width: 56,
        height: 43,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 310,
        width: 56,
        height: 43,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 740,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 695,
        width: 56,
        height: 43,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 650,
        width: 56,
        height: 43,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 740,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 695,
        width: 56,
        height: 43,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 1220,
        y: 650,
        width: 56,
        height: 43,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: 'F',
        type: 'Image',
        x: 481.68,
        y: 242.63,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/F.png'],
      },
      {
        name: 'G',
        type: 'Image',
        x: 960.32,
        y: 247.11,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/G.png'],
      },
      {
        name: 'H',
        type: 'Image',
        x: 482.39,
        y: 580.09,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/H.png'],
      },
      {
        name: 'I',
        type: 'Image',
        x: 964.17,
        y: 584.29,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/I.png'],
      },
      {
        name: 'F-3',
        type: 'PayoutText',
        x: 800,
        y: 400,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'F-4',
        type: 'PayoutText',
        x: 800,
        y: 355,
        width: 160,
        height: 43,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'F-5',
        type: 'PayoutText',
        x: 800,
        y: 310,
        width: 160,
        height: 43,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'G-3',
        type: 'PayoutText',
        x: 1280,
        y: 400,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'G-4',
        type: 'PayoutText',
        x: 1280,
        y: 355,
        width: 160,
        height: 43,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'G-5',
        type: 'PayoutText',
        x: 1280,
        y: 310,
        width: 160,
        height: 43,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'H-3',
        type: 'PayoutText',
        x: 800,
        y: 740,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'H-4',
        type: 'PayoutText',
        x: 800,
        y: 695,
        width: 160,
        height: 43,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'H-5',
        type: 'PayoutText',
        x: 800,
        y: 650,
        width: 160,
        height: 43,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'I-3',
        type: 'PayoutText',
        x: 1280,
        y: 740,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'I-4',
        type: 'PayoutText',
        x: 1280,
        y: 695,
        width: 160,
        height: 43,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'I-5',
        type: 'PayoutText',
        x: 1280,
        y: 650,
        width: 160,
        height: 43,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 536,
        y: 132,
        width: 852,
        height: 788,
        alpha: 0.01,
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 400,
        width: 56,
        height: 43,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 355,
        width: 56,
        height: 43,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 740,
        y: 310,
        width: 56,
        height: 43,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 56,
        },
      },
      {
        name: 'J',
        type: 'Image',
        x: 481.44,
        y: 240.08,
        width: 258,
        height: 278,
        scale: 1,
        images: ['images/main/items/static/J.png'],
      },
      {
        name: 'PaytableEntity-symbols-header-text',
        type: 'Text',
        x: 0,
        y: 150,
        width: 1920,
        height: 100.33,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'J-3',
        type: 'PayoutText',
        x: 800,
        y: 400,
        width: 160,
        height: 43,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'J-4',
        type: 'PayoutText',
        x: 800,
        y: 355,
        width: 160,
        height: 43,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
      {
        name: 'J-5',
        type: 'PayoutText',
        x: 800,
        y: 310,
        width: 160,
        height: 43,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 160,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bg',
        type: 'Graphics',
        x: 536,
        y: 132,
        width: 852,
        height: 788,
        alpha: 0.01,
      },
      {
        name: 'PaytableEntity-lines-header-text',
        type: 'Text',
        x: 0,
        y: 150,
        width: 1920,
        height: 100.33,
        text: 'linesHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'PaytableEntity-lines-describe-text',
        type: 'Text',
        x: 482,
        y: 725.5,
        width: 956,
        height: 152.33,
        text: 'payPaytable',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 956,
        },
      },
      {
        name: '1l',
        type: 'Image',
        x: 480,
        y: 288,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline1.png'],
      },
      {
        name: '2l',
        type: 'Image',
        x: 680,
        y: 288,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline2.png'],
      },
      {
        name: '3l',
        type: 'Image',
        x: 880,
        y: 288,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline3.png'],
      },
      {
        name: '4l',
        type: 'Image',
        x: 1080,
        y: 288,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline4.png'],
      },
      {
        name: '5l',
        type: 'Image',
        x: 1280,
        y: 288,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline5.png'],
      },
      {
        name: '6l',
        type: 'Image',
        x: 480,
        y: 395,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline6.png'],
      },
      {
        name: '7l',
        type: 'Image',
        x: 680,
        y: 395,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline7.png'],
      },
      {
        name: '8l',
        type: 'Image',
        x: 880,
        y: 395,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline8.png'],
      },
      {
        name: '9l',
        type: 'Image',
        x: 1080,
        y: 395,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline9.png'],
      },
      {
        name: '10l',
        type: 'Image',
        x: 1280,
        y: 395,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline10.png'],
      },
      {
        name: '11l',
        type: 'Image',
        x: 480,
        y: 500,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline11.png'],
      },
      {
        name: '12l',
        type: 'Image',
        x: 680,
        y: 500,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline12.png'],
      },
      {
        name: '13l',
        type: 'Image',
        x: 880,
        y: 500,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline13.png'],
      },
      {
        name: '14l',
        type: 'Image',
        x: 1080,
        y: 500,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline14.png'],
      },
      {
        name: '15l',
        type: 'Image',
        x: 1280,
        y: 500,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline15.png'],
      },
      {
        name: '16l',
        type: 'Image',
        x: 480,
        y: 610,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline16.png'],
      },
      {
        name: '17l',
        type: 'Image',
        x: 680,
        y: 610,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline17.png'],
      },
      {
        name: '18l',
        type: 'Image',
        x: 880,
        y: 610,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline18.png'],
      },
      {
        name: '19l',
        type: 'Image',
        x: 1080,
        y: 610,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline19.png'],
      },
      {
        name: '20l',
        type: 'Image',
        x: 1280,
        y: 610,
        width: 158,
        height: 93,
        scale: 0.56,
        images: ['images/main/winlines/winline20.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/paytable.png'],
      },
    },
  },
  {
    name: 'GameRulesEntity',
    objects: [
      {
        name: 'GameRulesEntity-text',
        type: 'Text',
        x: 525.17,
        y: 6.83,
        width: 869,
        height: 196,
        text: 'rulesHeader',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 80,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 869,
        },
      },
      {
        name: 'GameRulesEntity-about-game-text',
        type: 'Text',
        x: 671.17,
        y: 167.17,
        width: 576,
        height: 62.67,
        text: 'about',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 576,
        },
      },
      {
        name: 'GameRulesEntity-about-describe-text',
        type: 'Text',
        x: 506.83,
        y: 248.5,
        width: 913,
        height: 88.33,
        text: 'aboutDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 913,
        },
      },
      {
        name: 'GameRulesEntity-return-player-text',
        type: 'Text',
        x: 462.86,
        y: 384.18,
        width: 998.67,
        height: 79.79,
        text: 'return',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 998.67,
        },
      },
      {
        name: 'GameRulesEntity-return-player-describe-text',
        type: 'RtpText',
        x: 494.55,
        y: 436.43,
        width: 933,
        height: 105.33,
        text: 'returnDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 933,
        },
      },
      {
        name: 'GameRulesEntity-how-to-play-text',
        type: 'Text',
        x: 668.17,
        y: 1027.18,
        width: 580.33,
        height: 62.67,
        text: 'howPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 580.33,
        },
      },
      {
        name: 'GameRulesEntity-how-to-play-describe-text',
        type: 'Text',
        x: 492.5,
        y: 1094.18,
        width: 933,
        height: 107.33,
        text: 'howPlayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 933,
        },
      },
      {
        name: 'GameRulesEntity-hot-features-text',
        type: 'Text',
        x: 661.5,
        y: 1129.83,
        width: 580.33,
        height: 62.67,
        context: { jackpot: true },
        text: 'hotFeatures',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 580.33,
        },
      },
      {
        name: 'GameRulesEntity-jackpot-text',
        type: 'Text',
        x: 493.5,
        y: 1211.83,
        width: 935.67,
        height: 41.33,
        context: { jackpot: true },
        text: 'jackpot',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 935.67,
        },
      },
      {
        name: 'GameRulesEntity-jackpot-describe-text',
        type: 'Text',
        x: 493,
        y: 1250.33,
        width: 935.67,
        height: 41.33,
        context: { jackpot: true },
        text: 'jackpotDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 935.67,
        },
      },
      {
        name: 'GameRulesEntity-scatter-text',
        type: 'Text',
        x: 492,
        y: 1487.33,
        width: 935.67,
        height: 41.33,
        text: 'scatter',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 935.67,
        },
      },
      {
        name: 'GameRulesEntity-scatter-describe-text',
        type: 'Text',
        x: 479.83,
        y: 1526,
        width: 964.67,
        height: 111.67,
        text: 'scatterDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 964.67,
        },
      },
      {
        name: 'GameRulesEntity-wild-text',
        type: 'Text',
        x: 493,
        y: 1690.34,
        width: 935.67,
        height: 41.33,
        text: 'wild',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 935.67,
        },
      },
      {
        name: 'GameRulesEntity-wild-describe-text',
        type: 'Text',
        x: 502.83,
        y: 1723.5,
        width: 915.67,
        height: 120.67,
        text: 'wildDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 915.67,
        },
      },
      {
        name: 'GameRulesEntity-button-functions-text',
        type: 'Text',
        x: 671.5,
        y: 4888.49,
        width: 586.33,
        height: 62.67,
        text: 'buttonFunctions',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 586.33,
        },
      },
      {
        name: 'GameRulesEntity-spin-describe-text',
        type: 'Text',
        x: 509.12,
        y: 5396.74,
        width: 268.67,
        height: 129.33,
        text: 'spinDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 268.67,
        },
      },
      {
        name: 'GameRulesEntity-spin-text',
        type: 'Text',
        x: 532.45,
        y: 5289.74,
        width: 219.33,
        height: 59.67,
        text: 'spin',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 219.33,
        },
      },
      {
        name: 'GameRulesEntity-bet-header-text',
        type: 'Text',
        x: 1186.83,
        y: 5290.32,
        width: 172.67,
        height: 43.67,
        text: 'betHeaderRules',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 172.67,
        },
      },
      {
        name: 'GameRulesEntity-bet-header-describe-text',
        type: 'Text',
        x: 1136.83,
        y: 5397.32,
        width: 268.67,
        height: 106.67,
        text: 'betHeaderDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 268.67,
        },
      },
      {
        name: 'GameRulesEntity-menu-text',
        type: 'Text',
        x: 600.83,
        y: 5569.32,
        width: 800,
        height: 59.67,
        text: 'menu',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
      },
      {
        name: 'GameRulesEntity-home-text',
        type: 'Text',
        x: 600.83,
        y: 5686.32,
        width: 800,
        height: 59.67,
        text: 'home',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
      },
      {
        name: 'GameRulesEntity-cashier-text',
        type: 'Text',
        x: 600.83,
        y: 5799.83,
        width: 800,
        height: 59.67,
        text: 'cashier',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
      },
      {
        name: 'GameRulesEntity-game-rules-text',
        type: 'Text',
        x: 600.83,
        y: 5915.83,
        width: 800,
        height: 59.67,
        text: 'gameRules',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
      },
      {
        name: 'GameRulesEntity-paytable-text',
        type: 'Text',
        x: 600.83,
        y: 6033.23,
        width: 800,
        height: 59.67,
        text: 'paytable',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
      },
      {
        name: 'GameRulesEntity-additional-text',
        type: 'Text',
        x: -4.95,
        y: 6400.98,
        width: 1920,
        height: 62.67,
        text: 'additional',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'GameRulesEntity-additional-describe-text',
        type: 'Text',
        x: -22.29,
        y: 6495.98,
        width: 1920,
        height: 45.17,
        text: 'additionalDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'GameRulesEntity-generated-text',
        type: 'Text',
        x: -22.29,
        y: 6619.98,
        width: 1920,
        height: 62.67,
        text: 'generated',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'GameRulesEntity-generated-describe-text',
        type: 'Text',
        x: -22.29,
        y: 6696.98,
        width: 1920,
        height: 59.17,
        text: 'generatedDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
      },
      {
        name: 'GameRulesEntity-game-settings-text',
        type: 'Text',
        x: 600.83,
        y: 6160.23,
        width: 800,
        height: 59.67,
        text: 'gameSettings',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
      },
      {
        name: 'GameRulesEntity-hot-features-text',
        type: 'Text',
        x: 660.09,
        y: 1244.18,
        width: 580.33,
        height: 62.67,
        context: { jackpot: false },
        text: 'hotFeatures',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 580.33,
        },
      },
      {
        name: 'GameRulesEntity-stop-header-text',
        type: 'Text',
        x: 836.67,
        y: 5290.32,
        width: 230,
        height: 43.67,
        text: 'startStopBtn',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 230,
        },
      },
      {
        name: 'GameRulesEntity-startstop-describe-text',
        type: 'Text',
        x: 817.67,
        y: 5397.32,
        width: 268.67,
        height: 106.67,
        text: 'startStopBtnDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 268.67,
        },
      },
      {
        name: 'GameRulesEntity-pays-text',
        type: 'Text',
        x: 436,
        y: 534.66,
        width: 1048,
        height: 62.67,
        text: 'pays',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-pays-describe-text',
        type: 'Text',
        x: 436,
        y: 611,
        width: 1048,
        height: 107.33,
        text: 'paysDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-pays2-describe-text',
        type: 'Text',
        x: 436,
        y: 699,
        width: 1048,
        height: 107.33,
        text: 'paysDescribeP',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-pays3-describe-text',
        type: 'Text',
        x: 436,
        y: 861.34,
        width: 1048,
        height: 107.33,
        text: 'paysDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-pays4-describe-text',
        type: 'Text',
        x: 436,
        y: 923.34,
        width: 1048,
        height: 107.33,
        text: 'paysDescribeE',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-bet-text',
        type: 'Text',
        x: 436,
        y: 3184.23,
        width: 1048,
        height: 62.67,
        text: 'betGame',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-bet-describe-text',
        type: 'Text',
        x: 436,
        y: 3280.9,
        width: 1048,
        height: 83.33,
        text: 'betGameDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-startstop-text',
        type: 'Text',
        x: 436,
        y: 3446.75,
        width: 1048,
        height: 62.67,
        text: 'startStop',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-startstop-describe-text',
        type: 'Text',
        x: 436,
        y: 3562.09,
        width: 1048,
        height: 110,
        text: 'startStopDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-startstop2-describe-text',
        type: 'Text',
        x: 436,
        y: 3674.09,
        width: 1048,
        height: 110,
        text: 'startStopDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-desktopv-text',
        type: 'Text',
        x: 436,
        y: 3810.75,
        width: 1048,
        height: 62.67,
        text: 'desktopVersion',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-desktopv-describe-text',
        type: 'Text',
        x: 436,
        y: 3935.09,
        width: 1048,
        height: 110,
        text: 'desktopVersionDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-desktopv2-describe-text',
        type: 'Text',
        x: 436,
        y: 4045.09,
        width: 1048,
        height: 110,
        text: 'desktopVersionDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-keyboard-text',
        type: 'Text',
        x: 436,
        y: 4532.96,
        width: 1048,
        height: 62.67,
        text: 'keyboard',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-keyboard-describe-text',
        type: 'Text',
        x: 436,
        y: 4644.62,
        width: 1048,
        height: 110,
        text: 'keyboardDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-keyboard3-describe-text',
        type: 'Text',
        x: 436,
        y: 4756.17,
        width: 1048,
        height: 77,
        text: 'keyboardDescribeE',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'scroll',
        type: 'Graphics',
        x: 0,
        y: 0,
        width: 1920,
        height: 6446.69,
        alpha: 0,
      },
      {
        name: 'GameRulesEntity-freespins-text',
        type: 'Text',
        x: 492,
        y: 1335.08,
        width: 935.67,
        height: 41.33,
        text: 'freespins',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 935.67,
        },
      },
      {
        name: 'GameRulesEntity-freespins-describe-text',
        type: 'Text',
        x: 479.83,
        y: 1385.25,
        width: 964.67,
        height: 77.67,
        text: 'freespinsDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 964.67,
        },
      },
      {
        name: 'GameRulesEntity-freespin-title-text',
        type: 'Text',
        x: 436,
        y: 2290.33,
        width: 1048,
        height: 62.67,
        text: 'freespinsGameRules',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-freespin1-describe-text',
        type: 'Text',
        x: 436,
        y: 2364.99,
        width: 1048,
        height: 121.33,
        text: 'freespinsGameRulesD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-freespin2-describe-text',
        type: 'Text',
        x: 436,
        y: 2486.66,
        width: 1048,
        height: 121.33,
        text: 'freespinsGameRulesE',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-freespin3-describe-text',
        type: 'Text',
        x: 436,
        y: 2610.66,
        width: 1048,
        height: 121.33,
        text: 'freespinsGameRulesS',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-freespin4-describe-text',
        type: 'Text',
        x: 436,
        y: 2734.24,
        width: 1048,
        height: 79.33,
        text: 'freespinsGameRulesC',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-freespin5-describe-text',
        type: 'Text',
        x: 436,
        y: 2816.66,
        width: 1048,
        height: 159.33,
        text: 'freespinsGameRulesR',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-freespin6-describe-text',
        type: 'Text',
        x: 436,
        y: 2976.66,
        width: 1048,
        height: 121.33,
        text: 'freespinsGameRulesI',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 572.44,
        y: 5092.74,
        width: 140,
        height: 140,
        scale: 0.54,
        images: ['images/main/buttons/spin-0.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 876,
        y: 5092.82,
        width: 140,
        height: 140,
        scale: 0.54,
        images: ['images/main/buttons/spin-1.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 1204,
        y: 5092.82,
        width: 140,
        height: 140,
        scale: 1,
        images: ['images/main/buttons/bet-button-0.png'],
      },
      {
        name: 'GameRulesEntity-keyboard-text',
        type: 'Text',
        x: 436,
        y: 4274.84,
        width: 1048,
        height: 62.67,
        text: 'leftHandMode',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-keyboard-describe-text',
        type: 'Text',
        x: 436,
        y: 4358.52,
        width: 1048,
        height: 110,
        text: 'leftHandModeDescription',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'HISTORY - tap to view your latest game bets and payout',
        type: 'Text',
        x: 600,
        y: 6273.05,
        width: 800,
        height: 59.67,
        text: 'history',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 28,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
      },
      {
        name: 'GameRulesEntity-maxbet-describe-text',
        type: 'Text',
        x: 436,
        y: 1991.86,
        width: 1048,
        height: 115.33,
        text: 'stikyWildDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-expwild-describe-text',
        type: 'Text',
        x: 436,
        y: 2193.41,
        width: 1048,
        height: 115.33,
        text: 'expandingWildDescribe',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-stykid-text',
        type: 'Text',
        x: 436,
        y: 1925.56,
        width: 1048,
        height: 62,
        text: 'stikyWild',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
      {
        name: 'GameRulesEntity-stykid-text',
        type: 'Text',
        x: 436,
        y: 2129.58,
        width: 1048,
        height: 62,
        text: 'expandingWild',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1048,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -424,
        y: 190,
        scale: 1,
        images: ['guide/entities/game_rules.png'],
      },
    },
  },
  {
    name: 'SettingsEntity',
    objects: [
      {
        name: 'settings',
        type: 'Text',
        width: 800,
        height: 56.67,
        text: 'settings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 50,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 800,
        },
        orientation: {
          land: {
            x: 560.65,
            y: 125.33,
          },
          port: {
            x: 128,
            y: 192,
          },
        },
      },
      {
        name: 'space',
        type: 'ToggleButton',
        width: 120,
        height: 60,
        hitzone: 1.5,
        runtime: { platform: 'desktop' },
        scale: 0.98,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 1232,
            y: 448,
          },
          port: {
            x: 803.32,
            y: 726.67,
          },
        },
      },
      {
        name: 'space',
        type: 'Text',
        width: 606.97,
        height: 55,
        runtime: { platform: 'desktop' },
        text: 'space',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 606.97,
        },
        orientation: {
          port: {
            x: 129.33,
            y: 735.83,
          },
          land: {
            x: 560,
            y: 448,
          },
        },
      },
      {
        name: 'sound',
        type: 'ToggleButton',
        width: 120,
        height: 60,
        hitzone: 1.5,
        scale: 0.98,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 1232,
            y: 352,
          },
          port: {
            x: 805.99,
            y: 592,
          },
        },
      },
      {
        name: 'sound',
        type: 'Text',
        width: 606.97,
        height: 55,
        text: 'sound',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 606.97,
        },
        orientation: {
          port: {
            x: 128,
            y: 596.17,
          },
          land: {
            x: 560,
            y: 352,
          },
        },
      },
      {
        name: 'left',
        type: 'ToggleButton',
        width: 120,
        height: 60,
        hitzone: 1.5,
        runtime: { platform: 'mobile,tablet' },
        scale: 0.98,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 1232,
            y: 448,
          },
          port: {
            x: 802,
            y: 726,
          },
        },
      },
      {
        name: 'left',
        type: 'Text',
        width: 606.97,
        height: 55,
        runtime: { platform: 'mobile,tablet' },
        text: 'leftHand',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 606.97,
        },
        orientation: {
          port: {
            x: 130,
            y: 742,
          },
          land: {
            x: 560,
            y: 448,
          },
        },
      },
      {
        name: 'turbo',
        type: 'Text',
        width: 658,
        height: 55,
        text: 'turboModeSettings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 658,
        },
        orientation: {
          land: {
            x: 560,
            y: 256,
          },
          port: {
            x: 122,
            y: 458,
          },
        },
      },
      {
        name: 'turbo',
        type: 'ToggleButton',
        width: 120,
        height: 60,
        hitzone: 1.5,
        scale: 0.98,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 1232,
            y: 252,
          },
          port: {
            x: 800,
            y: 464,
          },
        },
      },
      {
        name: 'fps',
        type: 'Text',
        width: 658,
        height: 55,
        text: 'fps',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 658,
        },
        orientation: {
          land: {
            x: 560,
            y: 544,
          },
          port: {
            x: 130,
            y: 888,
          },
        },
      },
      {
        name: 'cheat',
        type: 'Text',
        width: 658,
        height: 55,
        context: { debug: true },
        text: 'cheat',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 658,
        },
        orientation: {
          land: {
            x: 560,
            y: 640,
          },
          port: {
            x: 130,
            y: 1034,
          },
        },
      },
      {
        name: 'cheat',
        type: 'ToggleButton',
        width: 120,
        height: 60,
        context: { debug: true },
        hitzone: 1.5,
        scale: 0.98,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 1232,
            y: 629,
          },
          port: {
            x: 803,
            y: 1034,
          },
        },
      },
      {
        name: 'fps',
        type: 'ToggleButton',
        width: 120,
        height: 60,
        hitzone: 1.5,
        scale: 0.98,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 1232,
            y: 538,
          },
          port: {
            x: 803,
            y: 888,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'MenuEntity',
    objects: [
      {
        name: 'menuhome',
        type: 'ImageButton',
        width: 80,
        height: 80,
        direction: true,
        hitzone: 2,
        scale: 1,
        images: ['images/icons/menu-home.png'],
        orientation: {
          land: {
            x: 110,
            y: 140,
          },
          port: {
            x: 215,
            y: 1557.5,
            v: 1,
          },
        },
      },
      {
        name: 'menu-gamerules',
        type: 'RadioButton',
        width: 80,
        height: 80,
        direction: true,
        hitzone: 2,
        scale: 1,
        images: [
          'images/icons/menu-info-0.png',
          'images/icons/menu-info-1.png',
        ],
        orientation: {
          land: {
            x: 110,
            y: 360,
          },
          port: {
            x: 475,
            y: 1557.5,
            v: 1,
          },
        },
      },
      {
        name: 'menu-paytable',
        type: 'RadioButton',
        width: 80,
        height: 80,
        direction: true,
        hitzone: 2,
        scale: 1,
        images: [
          'images/icons/menu-paytable-0.png',
          'images/icons/menu-paytable-1.png',
        ],
        orientation: {
          land: {
            x: 110,
            y: 470,
          },
          port: {
            x: 605,
            y: 1557.5,
            v: 1,
          },
        },
      },
      {
        name: 'menucashier',
        type: 'ImageButton',
        width: 80,
        height: 80,
        direction: true,
        hitzone: 2,
        scale: 1,
        images: ['images/icons/menu-cashier-1.png'],
        orientation: {
          land: {
            x: 110,
            y: 250,
          },
          port: {
            x: 345,
            y: 1557.5,
            v: 1,
          },
        },
      },
      {
        name: 'menu-settings',
        type: 'RadioButton',
        width: 80,
        height: 80,
        direction: true,
        hitzone: 2,
        scale: 1,
        images: [
          'images/icons/menu-settings-0.png',
          'images/icons/menu-settings-1.png',
        ],
        orientation: {
          land: {
            x: 110,
            y: 580,
          },
          port: {
            x: 735,
            y: 1557.5,
            v: 1,
          },
        },
      },
      {
        name: 'menuhistory',
        type: 'ImageButton',
        width: 80,
        height: 80,
        direction: true,
        hitzone: 1.5,
        scale: 1,
        images: ['images/icons/menu-history-1.png'],
        orientation: {
          land: {
            x: 110,
            y: 690,
          },
          port: {
            x: 865,
            y: 1557.5,
            v: 1,
          },
        },
      },
      {
        name: 'ui-menu',
        type: 'RadioButton',
        width: 100,
        height: 100,
        deselect: true,
        direction: true,
        hitzone: 1,
        scale: 1,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 100,
            y: 794,
          },
          port: {
            x: 53,
            y: 1550,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIRegularEntity',
    objects: [
      {
        name: 'spin',
        type: 'SpinButton',
        width: 256.67,
        height: 256.67,
        direction: true,
        scale: 0.99,
        images: [
          'images/icons/spin-0.png',
          'images/icons/spin-1.png',
        ],
        orientation: {
          land: {
            x: 1684.33,
            y: 406,
          },
          port: {
            x: 416.45,
            y: 1432,
            v: 1,
          },
        },
      },
      {
        name: 'ui-bet',
        type: 'RadioButton',
        width: 135.67,
        height: 135.67,
        deselect: true,
        direction: true,
        hitzone: 1.5,
        scale: 0.97,
        images: [
          'images/icons/bet-button-0.png',
          'images/icons/bet-button-1.png',
        ],
        orientation: {
          port: {
            x: 231,
            y: 1527,
            v: 1,
          },
          land: {
            x: 1746.67,
            y: 698,
          },
        },
      },
      {
        name: 'ui-menu',
        type: 'RadioButton',
        width: 100,
        height: 100,
        deselect: true,
        direction: true,
        hitzone: 3,
        scale: 1,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 100,
            y: 794,
          },
          port: {
            x: 53,
            y: 1551,
            v: 1,
          },
        },
      },
      {
        name: 'autostop',
        type: 'ImageButton',
        width: 140,
        height: 140,
        direction: true,
        scale: 0.89,
        images: ['images/icons/stop-autoplay.png'],
        orientation: {
          port: {
            x: 909,
            y: 1526,
            v: 1,
          },
          land: {
            x: 1735.66,
            y: 54,
          },
        },
      },
      {
        name: 'ui-automenu',
        type: 'RadioButton',
        width: 140,
        height: 140,
        deselect: true,
        direction: true,
        scale: 1,
        images: [
          'images/icons/auto-menu-0.png',
          'images/icons/auto-menu-1.png',
        ],
        orientation: {
          land: {
            x: 1745.33,
            y: 64,
          },
          port: {
            x: 909,
            y: 1526,
            v: 1,
          },
        },
      },
      {
        name: 'autospin-text',
        type: 'AutoCountText',
        width: 100,
        height: 100,
        direction: true,
        text: '10',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 52,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          land: {
            x: 1762.33,
            y: 482,
          },
          port: {
            x: 492.32,
            y: 1508,
            v: 1,
          },
        },
      },
      {
        name: 'you-win',
        type: 'WinText',
        width: 412,
        height: 35,
        text: '$5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 412,
        },
        orientation: {
          port: {
            x: 327,
            y: 1785,
            v: 1,
          },
          land: {
            x: 770,
            y: 961,
            v: 1,
          },
        },
      },
      {
        name: 'free-bet-count',
        type: 'FreeBetLeft',
        width: 200,
        height: 35,
        text: '$5,00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 1405,
            y: 961,
            v: 1,
          },
          port: {
            x: 677.19,
            y: 1785,
            v: 1,
          },
        },
      },
      {
        name: 'you-win',
        type: 'Text',
        width: 270,
        height: 35,
        text: 'win',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 270,
        },
        orientation: {
          port: {
            x: 396,
            y: 1737,
            v: 1,
          },
          land: {
            x: 837.79,
            y: 926,
            v: 1,
          },
        },
      },
      {
        name: 'free-bet-text',
        type: 'FreeBetText',
        width: 270,
        height: 35,
        text: 'freeBetLeft',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 1364.23,
            y: 926,
            v: 1,
          },
          port: {
            x: 634.9,
            y: 1738.46,
            v: 1,
          },
        },
      },
      {
        name: 'sound-bg',
        type: 'Image',
        width: 140,
        height: 140,
        direction: true,
        scale: 1.04,
        images: ['images/underlay/circle-small.png'],
        orientation: {
          land: {
            x: 1744,
            y: 236,
          },
          port: {
            x: 706,
            y: 1526,
            v: 1,
          },
        },
      },
      {
        name: 'sound',
        type: 'ToggleButton',
        width: 105.42,
        height: 90.36,
        direction: true,
        scale: 1.51,
        images: [
          'images/icons/sound-0.png',
          'images/icons/sound-1.png',
        ],
        orientation: {
          land: {
            x: 1761.11,
            y: 259.63,
          },
          port: {
            x: 722.26,
            y: 1550,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIFreespinsEntity',
    objects: [
      {
        name: 'frame-spin',
        type: 'Image',
        width: 260,
        height: 260,
        direction: true,
        scale: 1,
        images: ['images/icons/spin-0.png'],
        orientation: {
          land: {
            x: 1684.33,
            y: 406,
          },
          port: {
            x: 413.33,
            y: 1427,
            v: 1,
          },
        },
      },
      {
        name: 'freespinsCount',
        type: 'FreespinsCountText',
        width: 248,
        height: 248,
        direction: true,
        text: '15',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 55,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 248,
        },
        orientation: {
          land: {
            x: 1689.24,
            y: 410.84,
          },
          port: {
            x: 420.67,
            y: 1434.33,
            v: 1,
          },
        },
      },
      {
        name: 'total-name-p',
        type: 'Text',
        width: 306.67,
        height: 35,
        text: 'youWin',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 306.67,
        },
        orientation: {
          port: {
            x: 528,
            y: 1737,
            v: 1,
          },
        },
      },
      {
        name: 'total-name',
        type: 'Text',
        width: 300,
        height: 35,
        text: 'youWin',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 300,
        },
        orientation: {
          land: {
            x: 1350.42,
            y: 926,
            v: 1,
          },
        },
      },
      {
        name: 'total-value-p',
        type: 'FreespinsTotalWinText',
        width: 482,
        height: 35,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 482,
        },
        orientation: {
          port: {
            x: 446,
            y: 1785,
            v: 1,
          },
        },
      },
      {
        name: 'total-value',
        type: 'FreespinsTotalWinText',
        width: 412,
        height: 35,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 412,
        },
        orientation: {
          land: {
            x: 1291.28,
            y: 961,
            v: 1,
          },
        },
      },
      {
        name: 'you-win-text-fs',
        type: 'Text',
        width: 200,
        height: 35,
        text: 'youWinName',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 200,
        },
        orientation: {
          land: {
            x: 384,
            y: 927.13,
            v: 1,
          },
          port: {
            x: 304,
            y: 1737,
            v: 1,
          },
        },
      },
      {
        name: 'you-win-fs',
        type: 'WinText',
        width: 435.34,
        height: 35,
        text: '$5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 435.34,
        },
        orientation: {
          port: {
            x: 194.66,
            y: 1785,
            v: 1,
          },
          land: {
            x: 269.13,
            y: 959.87,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIGeneralEntity',
    objects: [
      {
        name: 'bet-name',
        type: 'Text',
        width: 200,
        height: 35,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'right',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 200,
        },
        orientation: {
          land: {
            x: 1687,
            y: 926,
            v: 1,
          },
        },
      },
      {
        name: 'balance-name',
        type: 'Text',
        width: 200,
        height: 35,
        text: 'balance',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'left',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 200,
        },
        orientation: {
          port: {
            x: 48,
            y: 1737,
            v: 1,
          },
          land: {
            x: 39.5,
            y: 926,
            v: 1,
          },
        },
      },
      {
        name: 'bet-value',
        type: 'BetText',
        width: 351.52,
        height: 35,
        text: '$ 2',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 351.52,
        },
        orientation: {
          land: {
            x: 1534.15,
            y: 961,
            v: 1,
          },
        },
      },
      {
        name: 'balance-value',
        type: 'BalanceText',
        width: 428.65,
        height: 35,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 428.65,
        },
        orientation: {
          port: {
            x: 48,
            y: 1785,
            v: 1,
          },
          land: {
            x: 39.67,
            y: 961,
            v: 1,
          },
        },
      },
      {
        name: 'bet-name-p',
        type: 'Text',
        width: 200,
        height: 35,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'right',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 200,
        },
        orientation: {
          port: {
            x: 848,
            y: 1737,
            v: 1,
          },
        },
      },
      {
        name: 'bet-value-p',
        type: 'BetText',
        width: 350,
        height: 35,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 350,
        },
        orientation: {
          port: {
            x: 698,
            y: 1785,
            v: 1,
          },
        },
      },
      {
        name: 'timer-clock',
        type: 'TimerText',
        width: 100,
        height: 35,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          land: {
            x: 40,
            y: 1020,
            v: 1,
          },
          port: {
            x: 48,
            y: 1878,
            v: 1,
          },
        },
      },
      {
        name: 'timer-name',
        type: 'Text',
        width: 149.1,
        height: 35,
        text: 'timeElapsed',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 149.1,
        },
        orientation: {
          land: {
            x: 150,
            y: 1020,
            v: 1,
          },
          port: {
            x: 150.35,
            y: 1878,
            v: 1,
          },
        },
      },
      {
        name: 'net-balance',
        type: 'NetPosition',
        width: 163.89,
        height: 35,
        text: '',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 163.89,
        },
        orientation: {
          land: {
            x: 1721,
            y: 1020,
            v: 1,
          },
          port: {
            x: 880,
            y: 1878,
            v: 1,
          },
        },
      },
      {
        name: 'net-name',
        type: 'Text',
        width: 150.35,
        height: 35,
        text: 'netPosition',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'right',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 150.35,
        },
        orientation: {
          land: {
            x: 1568,
            y: 1020,
            v: 1,
          },
          port: {
            x: 726,
            y: 1878,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreespinsEndEntity',
    objects: [
      {
        name: 'fs-back',
        type: 'Image',
        width: 3200,
        height: 1561.92,
        scale: 2.78,
        images: ['images/init/fs-back-land.jpeg'],
        orientation: {
          land: {
            x: -800,
            y: -241.62,
          },
        },
      },
      {
        name: 'backp',
        type: 'Image',
        width: 1480,
        height: 2320,
        scale: 1.93,
        images: ['images/init/fs-back-port.jpeg'],
        orientation: {
          port: {
            x: -200,
            y: -200,
          },
        },
      },
      {
        name: 'hands_03_pop_start_land',
        type: 'TriggerSpine',
        width: 1920,
        height: 1080,
        animation: 'hands-03-pop-start-land',
        spine: 'animations/spine/fsBackground/skeleton.json',
        orientation: {
          land: {
            x: -100,
            y: -100,
            scale: 1,
          },
        },
      },
      {
        name: 'fs-end-port',
        type: 'TriggerSpine',
        width: 1080,
        height: 1920,
        animation: 'popup-start-port',
        hide: false,
        oriented: false,
        scale: 0.6,
        spine: 'animations/spine/fsBackground/skeleton.json',
        orientation: {
          port: {
            x: -550,
            y: -1000,
          },
        },
      },
      {
        name: 'hands_02_pop_start_land',
        type: 'TriggerSpine',
        width: 1920,
        height: 1080,
        animation: 'hands-02-pop-start-land',
        spine: 'animations/spine/fsBackground/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -40,
            scale: 1,
          },
        },
      },
      {
        name: 'freenspinsText',
        type: 'FreespinsTotalWinPopupText',
        width: 1476.14,
        height: 210.47,
        fontBitmap: 'bitmap',
        letterSpacing: 10,
        text: '$ 50.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 150,
          align: 'center',
          valign: 'center',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1476.14,
        },
        orientation: {
          port: {
            x: -196.48,
            y: 1278.01,
          },
        },
      },
      {
        name: 'hands_01_pop_start_land',
        type: 'TriggerSpine',
        width: 1920,
        height: 1080,
        animation: 'hands-01-pop-start-land',
        spine: 'animations/spine/fsBackground/skeleton.json',
        orientation: {
          land: {
            x: -200,
            y: -50,
            scale: 1,
          },
        },
      },
      {
        name: 'people_pop_start_land',
        type: 'TriggerSpine',
        width: 1920,
        height: 1080,
        animation: 'people-pop-start-land',
        spine: 'animations/spine/fsBackground/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -40,
            scale: 1,
          },
        },
      },
      {
        name: 'freenspinsText-l',
        type: 'FreespinsTotalWinPopupText',
        width: 1915.29,
        height: 140.06,
        fontBitmap: 'bitmap',
        letterSpacing: 10,
        text: '$ 50.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 150,
          align: 'center',
          valign: 'center',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1915.29,
        },
        orientation: {
          land: {
            x: 11.42,
            y: 757.94,
          },
        },
      },
      {
        name: 'endFreespin',
        type: 'ImageButton',
        width: 497,
        height: 163,
        scale: 1,
        images: ['images/main/buttons/continue_btn_blood.png'],
        orientation: {
          port: {
            x: 293.59,
            y: 1527.02,
          },
          land: {
            x: 722.97,
            y: 886.74,
          },
        },
      },
      {
        name: 'endFreespinText',
        type: 'Text',
        width: 273.34,
        height: 104.65,
        hide: true,
        text: 'endFreeSpinButton',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 45,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 273.34,
        },
        orientation: {
          land: {
            x: 825.32,
            y: 947.96,
          },
        },
      },
      {
        name: 'endFreespinText-p',
        type: 'Text',
        width: 221.63,
        height: 96.81,
        hide: true,
        text: 'endFreeSpinButton',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 45,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 221.63,
        },
        orientation: {
          port: {
            x: 426.63,
            y: 1544.95,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreespinsStartEntity',
    objects: [
      {
        name: 'add-bg',
        type: 'Image',
        width: 3200,
        height: 1572.19,
        scale: 1.11,
        images: ['images/init/tunnel-land.jpeg'],
        orientation: {
          land: {
            x: -800,
            y: -247.31,
          },
        },
      },
      {
        name: 'add-bg-p',
        type: 'Image',
        width: 1468.24,
        height: 2314.12,
        scale: 1.92,
        images: ['images/init/tunnel-port.jpeg'],
        orientation: {
          port: {
            x: -150,
            y: -195.29,
          },
        },
      },
      {
        name: 'fs-start',
        type: 'TriggerSpine',
        width: 1920,
        height: 1080,
        animation: 'white-light-loop',
        hide: false,
        oriented: true,
        spine: 'animations/spine/transitions/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
          port: {
            x: -600,
            y: 300,
            scale: 1.17,
          },
        },
      },
      {
        name: 'light',
        type: 'ImageButton',
        width: 455,
        height: 215,
        scale: 1,
        images: ['images/main/buttons/btn_start.png'],
        orientation: {
          land: {
            x: 737.29,
            y: 714.43,
          },
          port: {
            x: 296.53,
            y: 1145.94,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreespinsAddEntity',
    objects: [
      {
        name: 'add-bg',
        type: 'Image',
        width: 3200,
        height: 1581.26,
        scale: 1.12,
        images: ['images/init/tunnel-land.jpeg'],
        orientation: {
          land: {
            x: -800,
            y: -238.25,
          },
        },
      },
      {
        name: 'add-bg-p',
        type: 'Image',
        width: 1468.24,
        height: 2314.12,
        scale: 1.92,
        images: ['images/init/tunnel-port.jpeg'],
        orientation: {
          port: {
            x: -150,
            y: -195.29,
          },
        },
      },
      {
        name: 'fs-add',
        type: 'TriggerSpine',
        width: 1920,
        height: 1080,
        animation: 'reels-break',
        hide: false,
        oriented: true,
        spine: 'animations/spine/transitions/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
            scale: 1,
          },
          port: {
            x: -550,
            y: 300,
            scale: 1.17,
          },
        },
      },
      {
        name: '10fs',
        type: 'Image',
        width: 572,
        height: 142,
        scale: 1,
        images: ['images/main/logo/10_fs.png'],
        orientation: {
          land: {
            x: 692.57,
            y: 779,
          },
          port: {
            x: 274,
            y: 1474,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreebetEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 1920,
        height: 1920,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -420,
          },
          port: {
            x: -420,
            y: 0,
          },
        },
      },
      {
        name: 'bg',
        type: 'Image',
        width: 740,
        height: 510,
        scale: 1,
        images: ['images/underlay/free-bet-bg.png'],
        orientation: {
          land: {
            x: 590,
            y: 280.48,
          },
        },
      },
      {
        name: 'bg-p',
        type: 'Image',
        width: 740,
        height: 510,
        scale: 1,
        images: ['images/underlay/free-bet-bg.png'],
        orientation: {
          port: {
            x: 190,
            y: 630.71,
          },
        },
      },
      {
        name: 'FB-CLOSE',
        type: 'RadioButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 849.67,
            y: 642.33,
          },
          port: {
            x: 446.57,
            y: 986.43,
          },
        },
      },
      {
        name: 'text',
        type: 'Text',
        width: 224.83,
        height: 103.17,
        text: 'OK',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 224.83,
        },
        orientation: {
          land: {
            x: 849.33,
            y: 646,
          },
          port: {
            x: 447.58,
            y: 989.72,
          },
        },
      },
      {
        name: 'fb-end',
        type: 'FreeBetWinText',
        width: 741.67,
        height: 148.85,
        text: 'freeBetTotalWin',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 65,
          align: 'center',
          valign: 'center',
          fill: '#f99531',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 741.67,
        },
        orientation: {
          land: {
            x: 587.83,
            y: 449.58,
          },
          port: {
            x: 189.88,
            y: 793.43,
          },
        },
      },
      {
        name: 'fb-end',
        type: 'PopupText',
        width: 733.14,
        height: 158.28,
        text: 'freeBetEnd',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 43,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 733.14,
        },
        orientation: {
          land: {
            x: 594.76,
            y: 279.53,
          },
          port: {
            x: 190.57,
            y: 635.15,
          },
        },
      },
      {
        name: 'fb-add',
        type: 'FreeBetCountText',
        width: 741.67,
        height: 148.85,
        text: 'freeBetsCount',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 65,
          align: 'center',
          valign: 'center',
          fill: '#f99531',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 741.67,
        },
        orientation: {
          land: {
            x: 587.83,
            y: 449.58,
          },
          port: {
            x: 189.88,
            y: 797,
          },
        },
      },
      {
        name: 'fb-add',
        type: 'PopupText',
        width: 741.67,
        height: 148.85,
        text: 'congrats',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 43,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 741.67,
        },
        orientation: {
          land: {
            x: 589.67,
            y: 278.65,
          },
          port: {
            x: 191.86,
            y: 624.56,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'IntroScreenEntity',
    objects: [
      {
        name: 'b',
        type: 'Graphics',
        width: 1920,
        height: 1080,
        color: '0x101130',
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: 0,
          },
        },
      },
      {
        name: 'bp',
        type: 'Graphics',
        width: 1080,
        height: 1920,
        color: '0x101130',
        resize: true,
        orientation: {
          port: {
            x: 0,
            y: 0,
          },
        },
      },
      {
        name: 'back',
        type: 'Image',
        width: 3200,
        height: 1480,
        scale: 2.76,
        images: ['images/init/slot-aztec-landscape.jpeg'],
        orientation: {
          land: {
            x: -800,
            y: -200,
          },
        },
      },
      {
        name: 'back-p',
        type: 'Image',
        width: 1480,
        height: 2400,
        scale: 2.07,
        images: ['images/init/slot-aztec-portrait.jpeg'],
        orientation: {
          port: {
            x: -150,
            y: -300,
          },
        },
      },
      {
        name: 'close',
        type: 'GraphicsButton',
        width: 1920,
        height: 1920,
        alpha: 0,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -420,
          },
          port: {
            x: -420,
            y: 0,
          },
        },
      },
      {
        name: 'IntroScreenEntity-tap-to-play-text',
        type: 'Text',
        width: 1920,
        height: 117.02,
        customStyle: 'intro',
        tween: 'introTween',
        text: 'tapPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 60,
          align: 'center',
          valign: 'center',
          fill: '#e199ff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1920,
        },
        orientation: {
          land: {
            x: 16.85,
            y: 937.96,
          },
        },
      },
      {
        name: 'IntroScreenEntity-tap-to-play-port-text',
        type: 'Text',
        width: 1080,
        height: 125.68,
        customStyle: 'intro',
        tween: 'introTween',
        text: 'tapPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 60,
          align: 'center',
          valign: 'center',
          fill: '#ff99ff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 1080,
        },
        orientation: {
          port: {
            x: 5.61,
            y: 1520.19,
          },
        },
      },
      {
        name: 'underloader',
        type: 'Image',
        width: 676,
        height: 24,
        scale: 1,
        images: ['../base/images/loader/loader-gray.png'],
        orientation: {
          land: {
            x: 626.23,
            y: 977.32,
          },
          port: {
            x: 208.63,
            y: 1579.15,
          },
        },
      },
      {
        name: 'loaderline',
        type: 'Loader',
        width: 666,
        height: 16,
        scale: 1,
        images: ['../base/images/loader/loader-progress.png'],
        orientation: {
          land: {
            x: 628.71,
            y: 981.42,
          },
          port: {
            x: 213.46,
            y: 1583.21,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'SoundPopupEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 1920,
        height: 1920,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -420,
          },
          port: {
            x: -420,
            y: 0,
          },
        },
      },
      {
        name: 'sound-back',
        type: 'Image',
        width: 672,
        height: 346.84,
        scale: 1.08,
        images: ['images/underlay/soundBack.png'],
        orientation: {
          land: {
            x: 618,
            y: 358.67,
          },
          port: {
            x: 217,
            y: 754,
          },
        },
      },
      {
        name: 'sound-1',
        type: 'ImageButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: ['images/icons/button-0.png'],
        orientation: {
          land: {
            x: 708,
            y: 499,
          },
          port: {
            x: 284,
            y: 897,
          },
        },
      },
      {
        name: 'sound-0',
        type: 'ImageButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: ['images/icons/button-0.png'],
        orientation: {
          land: {
            x: 986,
            y: 499,
          },
          port: {
            x: 608,
            y: 896,
          },
        },
      },
      {
        name: 'enable-sound',
        type: 'Text',
        width: 698.67,
        height: 76.33,
        text: 'soundQuestion',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 43,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 698.67,
        },
        orientation: {
          land: {
            x: 600,
            y: 399,
          },
          port: {
            x: 215,
            y: 782.67,
          },
        },
      },
      {
        name: 'sound-yes',
        type: 'Text',
        width: 109,
        height: 105,
        text: 'soundYes',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 109,
        },
        orientation: {
          land: {
            x: 800,
            y: 500,
          },
          port: {
            x: 355.33,
            y: 896,
          },
        },
      },
      {
        name: 'sound-no',
        type: 'Text',
        width: 109,
        height: 105,
        text: 'soundNo',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 109,
        },
        orientation: {
          land: {
            x: 1070,
            y: 500,
          },
          port: {
            x: 689.33,
            y: 898,
          },
        },
      },
      {
        name: 'sound-yes-pic',
        type: 'Image',
        width: 48.05,
        height: 53.04,
        scale: 0.81,
        images: ['images/icons/sound-1.png'],
        orientation: {
          land: {
            x: 734.17,
            y: 524.15,
          },
          port: {
            x: 304.33,
            y: 920.83,
          },
        },
      },
      {
        name: 'sound-no-pic',
        type: 'Image',
        width: 70,
        height: 60,
        scale: 1,
        images: ['images/icons/sound-0.png'],
        orientation: {
          land: {
            x: 1010.33,
            y: 522,
          },
          port: {
            x: 633,
            y: 919.33,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'PopupEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 1920,
        height: 1920,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -420,
          },
          port: {
            x: -420,
            y: 0,
          },
        },
      },
      {
        name: 'image',
        type: 'PopupButton',
        width: 226,
        height: 103,
        scale: 1.03,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 836.33,
            y: 649,
          },
          port: {
            x: 443,
            y: 940,
          },
        },
      },
      {
        name: 'text',
        type: 'PopupButton',
        width: 224.83,
        height: 103.17,
        text: 'OK',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 224.83,
        },
        orientation: {
          land: {
            x: 836,
            y: 652.67,
          },
          port: {
            x: 444.01,
            y: 943.29,
          },
        },
      },
      {
        name: 'body',
        type: 'PopupText',
        width: 951,
        height: 336.85,
        text: 'NO INTERNET CONNECTION.\nPLEASE CHECK YOUR CONNECTION\nAND RELOAD THE GAME TO CONTINUE',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 43,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 951,
        },
        orientation: {
          land: {
            x: 483,
            y: 202.65,
          },
          port: {
            x: 74.01,
            y: 560.27,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'FullscreenEntity',
    objects: [
      {
        name: 'fullscreen',
        type: 'GraphicsButton',
        width: 1920,
        height: 1920,
        alpha: 0.5,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -420,
          },
          port: {
            x: -420,
            y: 0,
          },
        },
      },
      {
        name: 'tapa',
        type: 'Image',
        width: 252,
        height: 425,
        runtime: {
          os: 'android',
          platform: 'mobile,tablet',
        },
        scale: 1,
        images: ['images/icons/fullscreen-1.png'],
        orientation: {
          land: {
            x: 847.33,
            y: 328,
          },
          port: {
            x: 427,
            y: 745.67,
          },
        },
      },
      {
        name: 'tap',
        type: 'AnimationSpine',
        width: 329,
        height: 471,
        runtime: {
          os: 'ios',
          platform: 'mobile,tablet',
        },
        spine: 'animations/spine/fullscreen/skeleton.json',
        orientation: {
          land: {
            x: 796,
            y: 295,
            scale: 1,
          },
          port: {
            x: 394,
            y: 715,
            scale: 1,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'LoadingEntity',
    objects: [
      {
        name: 'logoanim',
        type: 'LogoSpine',
        width: 1920,
        height: 1080,
        spine: 'brand/anim/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
          },
          port: {
            x: -820,
            y: 400,
          },
        },
      },
    ],
    properties: { parentGroup: 'INIT' },
  },
  {
    name: 'UIGeneralOverlayEntity',
    objects: [
      {
        name: 'intro-clock-l',
        type: 'ClockText',
        width: 109.53,
        height: 40.8,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 29,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 109.53,
        },
        orientation: {
          land: {
            x: 1761.62,
            y: 9.06,
            v: -1,
          },
        },
      },
      {
        name: 'intro-clock-p',
        type: 'ClockText',
        width: 93.67,
        height: 31.67,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 29,
          align: 'left',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 93.67,
        },
        orientation: {
          port: {
            x: 981.55,
            y: 6.84,
            h: 1,
            v: -1,
          },
        },
      },
      {
        name: 'game-name',
        type: 'Text',
        width: 466.23,
        height: 29.59,
        alpha: 0.5,
        force: false,
        text: 'gameName',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 13.53,
            y: 0,
            h: -1,
            v: -1,
          },
          port: {
            x: 23.8,
            y: 8.82,
            h: -1,
            v: -1,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
]
